<div class="noResults">
  <div class="searchResultsPresent">
    @if (!resultPresent) {
      <div>
        <a (click)="redirectToHelpCenter()" class="help-link">
          View all Help Topics
        </a>
      </div>
    }
  </div>
</div>
